import { Sparkles, DollarSign, Users, Heart } from "lucide-react";
import { Card } from "@/components/ui/card";

export const DemoWelcome = () => {
  return (
    <Card className="p-6 bg-card/95 backdrop-blur-sm border-border/50">
      <div className="text-center space-y-4">
        {/* Logo/Icon */}
        <div className="w-20 h-20 mx-auto rounded-full bg-gradient-to-br from-primary/30 to-primary/10 flex items-center justify-center border-2 border-primary/20">
          <img 
            src="/logo/wellness-logo.png" 
            alt="Wellness Cowgirl" 
            className="w-14 h-14 object-contain"
          />
        </div>
        
        <div className="space-y-2">
          <h3 className="font-display text-xl font-semibold text-foreground">Welcome to Wellness Cowgirl</h3>
          <p className="text-muted-foreground text-sm">
            More than an event finder — it's your wellness community
          </p>
        </div>
        
        {/* Differentiators */}
        <div className="grid grid-cols-3 gap-2 pt-2">
          <div className="flex flex-col items-center gap-1.5 p-3 rounded-xl bg-gradient-to-br from-green-500/10 to-green-600/5 border border-green-500/20">
            <div className="w-8 h-8 rounded-full bg-green-500/20 flex items-center justify-center">
              <DollarSign className="w-4 h-4 text-green-500" />
            </div>
            <span className="text-xs font-medium text-foreground">Free to Join</span>
            <span className="text-[10px] text-muted-foreground">No membership fees</span>
          </div>
          <div className="flex flex-col items-center gap-1.5 p-3 rounded-xl bg-gradient-to-br from-primary/10 to-primary/5 border border-primary/20">
            <div className="w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center">
              <Users className="w-4 h-4 text-primary" />
            </div>
            <span className="text-xs font-medium text-foreground">Never Alone</span>
            <span className="text-[10px] text-muted-foreground">Buddy system</span>
          </div>
          <div className="flex flex-col items-center gap-1.5 p-3 rounded-xl bg-gradient-to-br from-pink-500/10 to-pink-600/5 border border-pink-500/20">
            <div className="w-8 h-8 rounded-full bg-pink-500/20 flex items-center justify-center">
              <Heart className="w-4 h-4 text-pink-500" />
            </div>
            <span className="text-xs font-medium text-foreground">Real Community</span>
            <span className="text-[10px] text-muted-foreground">Friends & herds</span>
          </div>
        </div>
        
        {/* Tagline */}
        <div className="pt-2">
          <p className="text-xs text-primary font-medium flex items-center justify-center gap-1">
            <Sparkles className="w-3 h-3" />
            San Antonio's wellness community
            <Sparkles className="w-3 h-3" />
          </p>
        </div>
      </div>
    </Card>
  );
};
